import HcrDetailsBox from "components/common/HcrDetailsBox";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { currentClaimFormDataThunk, downloadClaimForm } from "store/thunk/hcr.thunk";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import Checkbox from "components/Semantic/Checkbox";
import { usePdf } from "@mikecousins/react-pdf";
import blankPdf from "assets/blank.pdf";
import PaymentCard from "./components/modals/PaymentCard";
import { toast } from "react-toastify";

const ClaimForm = () => {
  const hcrId: any = useParams();
  const navigate = useNavigate();
  const canvasRef: any = useRef(null);
  const dispatch = useAppDispatch();

  const [isAgreed, setIsAgreed] = useState(false);
  const [claimForm, setClaimForm] = useState<Blob | null>(null);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const hcrDetails = useAppSelector((state) => state.rootReducer.hcrSlice.currentClaimForm);
  const isLoading = useAppSelector((state) => state.rootReducer.hcrSlice.updateFormLoading);

  const { pdfDocument } = usePdf({
    file: pdfUrl || blankPdf,
    page: 1,
    canvasRef
  });

  useEffect(() => {
    dispatch(currentClaimFormDataThunk(hcrId.id));
    dispatch(downloadClaimForm(hcrId?.id))
      .unwrap()
      .then((data) => {
        if (data) setClaimForm(data);
      });
  }, [hcrId]);

  useEffect(() => {
    if (claimForm) {
      const objectUrl = URL.createObjectURL(claimForm);
      setPdfUrl(objectUrl);

      return () => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
      };
    }
  }, [claimForm]);

  const handleNavigate = () => {
    if (!isAgreed) {
      toast.error("Please accept disclaimer");
      return;
    }
    navigate("/hcr/download-form/" + hcrDetails?._id);
  };

  return (
    <>
      <HcrDetailsBox hideNext={true} hideProgress={true} hideSave={true} progress={100} title="Here’s Your Claim Form" isLoadingNext={isLoading}>
        <div className={`m-5 bg-[#F0F4FD] border-[1px] border-borderGray rounded-lg overflow-hidden ${!hcrDetails?.isComplete && "pointer-events-none blur-sm overscroll-none"}`}>
          <header className="p-5 font-bold">CLAIM FORM</header>
          <div className={`bg-white rounded-t-3xl shadow-all p-5 space-y-4 ${!hcrDetails?.isComplete && "hidden"}`}>
            {!pdfDocument ? (
              <div className="flex gap-3 items-center flex-col h-full">
                <div className="w-4 h-4 border-[2px] border-t-[#dea15c]  rounded-full animate-spin"></div>
                Loading PDF
              </div>
            ) : (
              <canvas ref={canvasRef} className="h-full w-full" />
            )}
          </div>
          {!hcrDetails?.isComplete && (
            <div className={`h-96 w-full overflow-hidden pointer-events-none`}>
              <img src={hcrDetails?.policyId?.insuranceCompanyId?.claimFileImageUrl} />
            </div>
          )}
          <div className={`p-5 bg-white `}>
            <Checkbox checkboxClassName={"w-8 h-6 min-w-6"} checked={isAgreed} onChange={() => setIsAgreed(!isAgreed)} labelClassName="text-xs md:text-sm ml-2" label="I hereby confirm that the Part A of this claim form will be duly signed by the policy holder and Part B will be signed and stamped by the hospital." />
          </div>
        </div>
        {hcrDetails?.isComplete && (
          <div className={`fixed hidden md:relative bottom-0 z-10 bg-white  w-full rounded-b-lg py-3   border-t-[1px]  shadow-top overflow-hidden border-borderGray  flex-col md:flex`}>
            <div className="flex justify-center items-center gap-5 h-16 md:h-20 bg-white">
              <button onClick={handleNavigate} className={`bg-polyfix-gradient h-12 rounded-lg ${hcrDetails?.isComplete ? "md:min-w-48" : "md:min-w-80"} font-bold flex items-center justify-center gap-3 `}>
                <p>{hcrDetails?.isComplete ? "Next" : `Pay Rs. ${hcrDetails?.hcrLeadId?.paymentInfo?.feeAmount || 799} to generate the form`}</p>
              </button>
            </div>
          </div>
        )}
      </HcrDetailsBox>
      {hcrDetails?.isComplete && (
        <div className={`fixed flex md:relative bottom-0 z-10 bg-white  w-full rounded-b-lg py-3   border-t-[1px]  shadow-top overflow-hidden border-borderGray  flex-col md:hidden`}>
          <div className="flex justify-center items-center gap-5 h-16 md:h-20 bg-white">
            <button onClick={handleNavigate} className={`bg-polyfix-gradient h-12 rounded-lg ${hcrDetails?.isComplete ? "min-w-48" : "min-w-80"} font-bold flex items-center justify-center gap-3 `}>
              <p>{hcrDetails?.isComplete ? "Next" : `Pay Rs. ${hcrDetails?.hcrLeadId?.paymentInfo?.feeAmount || 799} to generate the form`}</p>
            </button>
          </div>
        </div>
      )}

      {!hcrDetails?.isComplete && <PaymentCard hcrFee={hcrDetails?.hcrLeadId?.paymentInfo?.feeAmount || 799} />}
    </>
  );
};

export default ClaimForm;
